import { PkCard } from '@uefadigital/panenka-react';
import type { ComponentProps, CSSProperties, ReactNode } from 'react';
import { memo, useMemo } from 'react';

import { useSponsor } from '../RandomSponsors/useSponsor';

import { trackSponsorElement } from '@services/GoogleTagManagerService';

const PkCardWithSponsor = (
  props: {
    sponsorName: string;
    enableSponsorColor?: boolean;
    children: ReactNode;
  } & ComponentProps<typeof PkCard>,
) => {
  const { sponsorName, children, style, enableSponsorColor = true, sponsorPosition = 'top-left' } = props;

  const { sponsor } = useSponsor(sponsorName);

  const trackingData = useMemo(() => {
    if (!sponsor) return null;
    const position = location.href.includes('/news/') ? 'card_news' : 'card_homepage';
    return {
      id: `${sponsor.code}-branded-card-${position}`,
      name: sponsor.code,
      creative: 'branded-card',
      position,
      item_category3: sponsor?.code ? 'sponsored' : undefined,
      item_category4: sponsor?.code,
    };
  }, [sponsor]);

  return (
    <PkCard
      {...props}
      ref={trackSponsorElement(trackingData, true)}
      sponsor={!!sponsor}
      sponsorImage={sponsor?.image}
      sponsorPosition={sponsorPosition}
      sponsorStripColor={enableSponsorColor && !!sponsor?.colour && 'sponsor-strip--color'}
      style={
        {
          ...style,
          '--pk-sponsor-strip--color': enableSponsorColor && sponsor?.colour,
        } as CSSProperties
      }
    >
      {children}
    </PkCard>
  );
};

export default memo(PkCardWithSponsor);
